/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "pspDevice",
            "endpoint": "https://f1h7rhox02.execute-api.eu-west-1.amazonaws.com/pro",
            "region": "eu-west-1"
        },
        {
            "name": "pspIot",
            "endpoint": "https://4oasclpco9.execute-api.eu-west-1.amazonaws.com/pro",
            "region": "eu-west-1"
        },
        {
            "name": "pspUser",
            "endpoint": "https://wbgj243lrg.execute-api.eu-west-1.amazonaws.com/pro",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:b0214951-939d-434f-ac53-f01121709739",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_CidzfiOD6",
    "aws_user_pools_web_client_id": "2oinpg5c6bpvu88g76isuskujt",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "pspwateringcanui-20230616123123-hostingbucket-pro",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d1jsgq0nv7i4ku.cloudfront.net"
};


export default awsmobile;
